// src/components/admin/dashboard/OrdersChart.tsx
import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

interface OrdersChartProps {
  data: {
    month: string;
    orders: number;
    revenue: number;
  }[];
}

const OrdersChart: React.FC<OrdersChartProps> = ({ data }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold mb-4">Orders Overview</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
            <XAxis 
              dataKey="month" 
              tickFormatter={(value) => {
                const [year, month] = value.split('-');
                return `${new Date(parseInt(year), parseInt(month)-1).toLocaleString('default', { month: 'short' })}`;
              }}
            />
            <YAxis />
            <Tooltip 
              formatter={(value: number) => [value, 'Orders']}
              labelFormatter={(label) => {
                const [year, month] = label.split('-');
                return new Date(parseInt(year), parseInt(month)-1).toLocaleString('default', { month: 'long', year: 'numeric' });
              }}
            />
            <Line 
              type="monotone" 
              dataKey="orders" 
              stroke="#251575" 
              strokeWidth={2}
              dot={{ fill: '#251575' }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default OrdersChart;